import PosterCard from "app/components/PosterCard";
import { useLayout } from "app/context/LayoutContext/hooks";
import { theme, Typography } from "kosmos-ui/lib";

import { OurPhilosophySectionContainer } from "./styles";

export default function OurPhilosophySection() {
  const { mobile, topbarHeight, announcementBarHeight } = useLayout();

  const headerHeight = topbarHeight + announcementBarHeight;

  return (
    <OurPhilosophySectionContainer>
      <PosterCard
        gradientFrom={theme.colorsPalette.blue.default}
        gradientTo={theme.colorsPalette.cyan.default}
        style={{
          height: "50vh",
          maxHeight: 440,
          maxWidth: 1200 - 144,
          marginTop: headerHeight,
        }}
      >
        <Typography
          as="h1"
          variant="title1"
          style={{ opacity: 0.4, marginBottom: mobile ? 8 : 0 }}
        >
          Por creadores.
        </Typography>

        <Typography as="h1" variant="title1">
          Para creadores.
        </Typography>

        <Typography
          as="h2"
          variant="paragraph1"
          style={{
            color: theme.colorsPalette.white.default,
            maxWidth: 560,
            fontWeight: theme.fontWeights.bold,
          }}
        >
          Cualquiera sea tu negocio, nuestro objetivo es que puedas llevarlo al
          mundo online sin fricciones, rápidamente y a un precio conveniente.
        </Typography>

        <Typography
          as="h2"
          variant="paragraph1"
          style={{
            color: theme.colorsPalette.white.default,
            maxWidth: 560,
            fontWeight: theme.fontWeights.bold,
          }}
        >
          Te sorprenderás cuán rápido podemos cumplir este objetivo.
        </Typography>
      </PosterCard>
    </OurPhilosophySectionContainer>
  );
}
